import React from "react";
import { OrbitComponent } from "../../../base-components/orbit-component/orbit-component";
import { SideMenuLinkIconWrapBase } from "./base/side-menu-link-icon-wrap-base.box";

export class CashierHistorySideMenuIcon extends OrbitComponent {
    render() {
        const ArrowsUpDownIcon = this.services.theme.currentTheme.icons.arrowsUpDownIcon;
        return <SideMenuLinkIconWrapBase>
            <ArrowsUpDownIcon />
        </SideMenuLinkIconWrapBase>;
    }
}
